import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ParsedActivityDateTimePipe } from './parsed-activity-date-time.pipe';

@NgModule({
  declarations: [ParsedActivityDateTimePipe],
  imports: [CommonModule],
  exports: [ParsedActivityDateTimePipe],
})
export class ParsedActivityDateTimeModule {}
